<template>
    <div class="fillcontain">
        <head-top></head-top>
        <div class="select_container">
            <el-select v-model="value" placeholder="全部" style="width: 200px">
                <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-input v-model="input" placeholder="机构名称" style="width: 200px"></el-input>
            <el-button type="primary" @click="searchQuery">搜索</el-button>
        </div>
        <div class="table_container">
            <el-table
                :data="tableData"
                highlight-current-row
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  width="100">
                </el-table-column>
                <el-table-column
                  property="organizationName"
                  label="机构名称">
                </el-table-column>
                <el-table-column
                  property="studentNum"
                  label="学员人数">
                </el-table-column>
                <el-table-column
                  property="userName"
                  label="联系人">
                </el-table-column>
                <el-table-column
                  property="phone"
                  label="电话号码">
                </el-table-column>
                <el-table-column
                  :formatter="formatDate"
                  property="createTime"
                  label="申请时间">
                </el-table-column>
                <el-table-column
                  fixed="right"
                  label="审核状态"
                  width="200">
                  <template slot-scope="scope" >
                    <el-button v-if="scope.row.examine!='2' && scope.row.examine!='0'" @click="adopt(scope.$index, scope.row)" type="text" size="small">通过</el-button>
                    <el-button v-if="scope.row.examine!='2' && scope.row.examine!='0'" @click="adoptno(scope.$index, scope.row)" type="text" size="small">不通过</el-button>
                    <span v-if="scope.row.examine=='0'">未通过</span>
                    <span v-if="scope.row.examine=='2'">通过</span>
                    <!--<el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
                  </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="20"
                layout="total, prev, pager, next"
                :total="total">
              </el-pagination>
            </div>

          <el-dialog title="机构申请" :visible.sync="dialogFormVisible" v-loading="loading">
            <el-form label-width="160px" ref="addForm">
              <p style="text-align: center;font: 18px/60px ''">您确定审核通过该机构吗？</p>
              <el-form-item label="每位机构会员返利金额">
                <el-input v-model="num" autocomplete="off" maxlength="8"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="addSubmit()">确 定</el-button>
            </div>
          </el-dialog>
        </div>
    </div>
</template>

<script>
    import headTop from '../components/headTop'
    import { getMechanism,getMechanismDel,getreview } from "../api/api"
    export default {
      data(){
        return {
          options: [{
            id: '',
            label: '全部'
          },{
            id: '0',
            label: '未通过'
          }, {
            id: '1',
            label: '审核中'
          }, {
            id: '2',
            label: '通过'
          }],
          value: '',
          tableData: [],
          offset: 0,
          limit: 20,
          total: 0,
          currentPage: 1,
          input: '',
          dialogFormVisible:false,
          loading:false,
          num:'',
          id:'',
          examine:'',
          userId:''
        }
      },
        components: {
          headTop,
        },
        created(){
          this.getMechanism();
        },
        methods: {
          //时间戳转换
          formatDate:function (value){
            let dateee = new Date(value.createTime).toJSON();
            return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
          },
          getMechanism(){
            let params={
              pageNum:this.currentPage,
              pageSize:this.limit,
              examine:this.value,
              organizationName:this.input
            };
            //机构申请列表
            getMechanism(params).then(res=>{
              this.tableData = res.pageInfo
              this.total = res.total
            }).catch(error=>{
              console.log(error);
            })
          },
          searchQuery(){
            //  查询
            let params={
              pageNum:this.currentPage,
              pageSize:this.limit,
              examine:this.value,
              organizationName:this.input
            };
            //机构申请列表
            getMechanism(params).then(res=>{
              this.tableData = res.pageInfo
              this.total = res.total
            }).catch(error=>{
              console.log(error);
            })
          },
          handleDelete(index, row){
            //删除
            this.$confirm('确认删除该记录吗？', '提示', {
              // type: 'warning'
            }).then(() => {
              let params={
                id:row.id,
                operationId:JSON.parse(sessionStorage.getItem('user')).id,
              };
              getMechanismDel(params).then(res=>{
                if (res.state == true) {
                  this.$message({
                    type: 'success',
                    message: res.msg
                  });
                  this.tableData.splice(index, 1);
                }else{
                  throw new Error(res.message)
                }
              }).catch(error=>{
                this.$message({
                  type: 'error',
                  message: res.msg
                });
              })
            })
          },
          adopt(index, row){
            this.dialogFormVisible = true
            this.id = row.id
            this.examine =index ;
            this.userId = row.userId
          },
          addSubmit(){
            if (this.num ==' ' || this.num <=0){
              this.$message({
                type: 'error',
                message: '请输入正确返现金额'
              });
            }else {
              let params = {
                id: this.id,
                operationId: JSON.parse(sessionStorage.getItem('user')).id,
                examine: 2,
                bkMoney:this.num,
                userId:this.userId
              };
              getreview(params).then(res => {
                if (res.state == true){
                  this.tableData[this.examine].examine = 2
                  this.dialogFormVisible = false
                } else {
                  this.$message({
                    type: 'error',
                    message: '请输入正确返现金额'
                  });
                }

              }).catch(error => {
                console.log(error);
              })
            }
          },
          adoptno(index, row){
            this.$confirm('是否确认不通过吗？', '提示', {
              // type: 'warning'
            }).then(() => {
              let params={
                id:row.id,
                operationId:JSON.parse(sessionStorage.getItem('user')).id,
                examine:0,
                bkMoney:-1,
                userId:row.userId
              };
              getreview(params).then(res=>{
                row.examine = 0;
              }).catch(error=>{
                console.log(error);
              })
            })
          },
          handleCurrentChange(val) {
          this.currentPage = val;
          this.getMechanism()
        },
        },
    }
</script>

<style lang="less">
    @import '../style/mixin';
</style>



// WEBPACK FOOTER //
// src/page/explain.vue